import React, { useEffect, useMemo, useState } from "react";
import { getDatabase, ref, onValue, update } from "firebase/database";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";


ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function VendeursPage({ uid }) {
  const db = getDatabase();
   const navigate = useNavigate();
  const [vendeurs, setVendeurs] = useState([]);
  const [orders, setOrders] = useState([]);
  const [month, setMonth] = useState(
    new Date().toISOString().slice(0, 7) // YYYY-MM
  );

  /* =====================
     تحميل البائعين
  ====================== */
  useEffect(() => {
    const vendeursRef = ref(db, `distributors/${uid}/vendeurs`);
    return onValue(vendeursRef, (snap) => {
      if (!snap.exists()) return setVendeurs([]);
      const data = snap.val();
      setVendeurs(
        Object.keys(data).map((id) => ({ id, ...data[id] }))
      );
    });
  }, [uid]);

  /* =====================
     تحميل الطلبات
  ====================== */
  useEffect(() => {
    const ordersRef = ref(db, `distributors/${uid}/orders`);
    return onValue(ordersRef, (snap) => {
      if (!snap.exists()) return setOrders([]);
      setOrders(Object.values(snap.val()));
    });
  }, [uid]);

  /* =====================
     حساب فترة الشهر
  ====================== */
  const { startOfMonth, endOfMonth } = useMemo(() => {
    const [y, m] = month.split("-");
    const start = new Date(y, m - 1, 1).getTime();
    const end = new Date(y, m, 0, 23, 59, 59).getTime();
    return { startOfMonth: start, endOfMonth: end };
  }, [month]);

  /* =====================
     إحصائيات البائعين
  ====================== */
  const stats = useMemo(() => {
    const result = {};

    orders.forEach((o) => {
      if (
        !o.vendeurId ||
        o.createdAt < startOfMonth ||
        o.createdAt > endOfMonth
      )
        return;

      if (!result[o.vendeurId]) {
        result[o.vendeurId] = { count: 0, total: 0 };
      }

      result[o.vendeurId].count += 1;
      result[o.vendeurId].total += Number(o.finalPrice || 0);
    });

    return result;
  }, [orders, startOfMonth, endOfMonth]);

  /* =====================
     Chart Data
  ====================== */
  const chartData = {
    labels: vendeurs.map((v) => `${v.name}`),
    datasets: [
      {
        label: "Total des ventes",
        data: vendeurs.map((v) => stats[v.id]?.total || 0),
        backgroundColor: "#2563eb",
      },
    ],
  };

  /* =====================
     Actions
  ====================== */
  const togglePermission = (id, val) =>
    update(ref(db), {
      [`distributors/${uid}/vendeurs/${id}/canEdit`]: val,
    });

  const toggleActive = (id, val) =>
    update(ref(db), {
      [`distributors/${uid}/vendeurs/${id}/active`]: val,
      [`users/${id}/active`]: val,
    });
   

  return (
    <div>
     <button
  onClick={() => navigate("/add-vendeur")}
  style={{
    marginBottom: 20,
    padding: "10px 16px",
    borderRadius: 8,
    background: "#2563eb",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  }}
>
  ➕ Ajouter un vendeur
</button>
      <h2>📊 Performance des vendeurs</h2>
 
      {/* فلترة الشهر */}
      <div style={{ marginBottom: 20 }}>
        <label>
          📅 Mois :
          <input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            style={{ marginLeft: 10 }}
          />
        </label>
      </div>

      {/* Chart */}
      <div style={{ maxWidth: 800, marginBottom: 30 }}>
        <Bar data={chartData} />
      </div>

      {/* Liste vendeurs */}
      {vendeurs.map((v) => (
        <div
          key={v.id}
          style={{
            padding: 16,
            marginBottom: 12,
            borderRadius: 10,
            background: "#f9fafb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontWeight: 600 }}>
              {v.name} {v.lastName}
            </div>
            <div style={{ fontWeight: 200 }}>
              {v.email} 
            </div>

            <div style={{ fontSize: 14, color: "#6b7280" }}>
              🧾 {stats[v.id]?.count || 0} ventes
            </div>

            <div style={{ color: "#16a34a", fontWeight: 500 }}>
              💰 {stats[v.id]?.total || 0} DA
            </div>
          </div>

          <div style={{ display: "flex", gap: 14 }}>
            <button onClick={() => navigate(`/edit-vendeur/${v.id}`)}
              style={{
    marginBottom: 20,
    padding: "10px 16px",
    borderRadius: 8,
    background: "#2563eb",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  }}>
             ✏️ Modifier
             </button>
            <label>
              <input
                type="checkbox"
                checked={v.canEdit || false}
                onChange={(e) =>
                  togglePermission(v.id, e.target.checked)
                }
              />{" "}
              Modification Autorisé
            </label>

            <label>
              <input
                type="checkbox"
                checked={v.active || false}
                onChange={(e) =>
                  toggleActive(v.id, e.target.checked)
                }
              />{" "}
              Compte Actif
            </label>
          </div>
        </div>
      ))}
    </div>
  );
}

export default VendeursPage;
